import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FileCheck2, FileText, GitMerge, X } from 'lucide-react';
import { HudButton } from '../hud';

/** CctpEnrichDialog — fusionne un CCTP dans la matériauthèque existante. */
export const CctpEnrichDialog = ({ materialsCount, onClose, onConfirm, busy }) => {
  const [file, setFile] = useState(null);
  const onDrop = useCallback((acc) => { if (acc?.[0]) setFile(acc[0]); }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: { 'application/pdf': ['.pdf'] }, multiple: false });

  return (
    <>
      <div className="fixed inset-0 bg-black/65 backdrop-blur-sm z-[1400]" onClick={busy ? undefined : onClose} />
      <div role="dialog" aria-modal="true" data-testid="materialtheque-enrich-dialog"
        className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[92%] max-w-[520px] rounded-2xl z-[1410]"
        style={{ background: 'linear-gradient(to bottom, #0F0F12, #09090B)', border: '1px solid var(--c-border)', boxShadow: 'var(--shadow-cockpit)' }}>
        <div className="px-6 py-5 flex items-start justify-between" style={{ borderBottom: '1px solid var(--c-border)' }}>
          <div>
            <span className="hud-eyebrow hud-eyebrow-gold">Fusion CCTP</span>
            <h3 className="mt-1 font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--c-text)', fontSize: 20 }}>Enrichir avec le CCTP</h3>
            <p className="mt-1 text-[12.5px]" style={{ color: 'var(--c-text-muted)' }}>
              Les {materialsCount} matériaux actuels sont conservés : le CCTP complète références, formats et finitions manquants, puis ajoute les prescriptions absentes.
            </p>
          </div>
          <button onClick={onClose} disabled={busy} className="hud-btn hud-btn-ghost hud-btn-sm aspect-square px-0" data-testid="materialtheque-enrich-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="px-6 py-5">
          <div {...getRootProps()} data-testid="materialtheque-enrich-dropzone"
            className="cursor-pointer rounded-xl px-5 py-8 flex flex-col items-center gap-3 text-center"
            style={{ border: `1.5px dashed ${isDragActive ? 'var(--c-gold)' : 'rgba(255,255,255,0.2)'}`, background: isDragActive ? 'rgba(217,160,91,0.06)' : 'transparent' }}>
            <input {...getInputProps()} />
            {file ? <FileCheck2 className="w-8 h-8" style={{ color: 'var(--c-gold)' }} strokeWidth={1.5} /> : <FileText className="w-8 h-8" style={{ color: 'var(--c-text-muted)' }} strokeWidth={1.5} />}
            <p className="text-[14px] font-medium" style={{ color: 'var(--c-text)' }}>{file ? file.name : 'Déposez le CCTP (PDF)'}</p>
            {file && <p className="text-[12px] hud-tabular" style={{ color: 'var(--c-text-muted)' }}>{(file.size / (1024 * 1024)).toFixed(2)} Mo</p>}
          </div>
        </div>
        <div className="px-6 py-4 flex items-center justify-end gap-2" style={{ borderTop: '1px solid var(--c-border)' }}>
          <HudButton variant="ghost" size="sm" onClick={onClose} disabled={busy} data-testid="materialtheque-enrich-cancel">Annuler</HudButton>
          <HudButton variant="primary" size="md" onClick={() => onConfirm(file)} disabled={busy || !file} leftIcon={<GitMerge className="w-4 h-4" />} data-testid="materialtheque-enrich-confirm">
            {busy ? 'Envoi…' : 'Fusionner le CCTP'}
          </HudButton>
        </div>
      </div>
    </>
  );
};

export default CctpEnrichDialog;
